<template>
    <el-button :type="type" class="round-button" :style="{width:size + 'px', height:size+'px'}">
        <span :style="{fontSize:fontSize + 'px'}"><slot></slot></span>
    </el-button>
</template>
<script type="text/javascript">
    export default {
        props: {
            'type': {
                'type': String,
                'default': 'info'
            },
            fontSize: {
                type: Number,
                'default': 14
            },
            size: {
                type: Number,
                'default': 60
            }
        }
    }
</script>
<style type="text/css" lang="scss" scoped>
    @import "~variable";

    .round-button {
        border-radius    : 50%;
        background-color : transparent;
        color            : inherit;

        &.el-button--success {
            color        : $color-success-2;
            border-color : $color-success-2;
        }
        &.el-button--info {
            color        : $color-info-2;
            border-color : $color-info-2;
        }
        &.el-button--warning {
            color        : $color-warning-2;
            border-color : $color-warning-2;
        }
        &.el-button--primary {
            color        : $color-primary;
            border-color : $color-primary;
        }
        &.el-button--purple {
            color        : $color-purple;
            border-color : $color-purple;
        }
    }
</style>


// WEBPACK FOOTER //
// roundButton.vue?15396290